import { addDays } from 'date-fns';

import { generateUUID } from '@topconagriculture/frontend-utils';

import { DragDropGroupState } from '../../../../../shared/Draggable/DraggableContext';
import { Feeding, FeedingPeriod } from '../../../../../store/entities/feeding/feeding.types';
import { Recipe } from '../../../../../store/entities/recipes/recipes.types';
import { GroupFormFeeding, GroupFormValue } from './GroupPartialForm';
import { ChangedKeys } from '../../../../../store/application/groupPreview/groupPreview.types';
import { transformFormValueToNumber } from '../../../../../core/helpers/utils/utils';

const hasLockedFeedings = (formFeedings: GroupFormFeeding[]) => {
  const hasLocked = formFeedings
    ? formFeedings.some((formRow) => formRow.items.some((rowItem) => rowItem.locked))
    : false;
  return hasLocked;
};

// const hasNewFeedings = (formFeedings: GroupFormFeeding[]) => {
//   const hasAddedFeedings = formFeedings
//     ? formFeedings.some((formRow) =>
//         formRow.items.some((rowItem) => typeof rowItem.feedingId === 'undefined' || rowItem.feedingId === newId),
//       )
//     : false;
//   return hasAddedFeedings;
// };

const formatFeedings = (formFeedings: GroupFormFeeding[], changedKey = 'loadWeight') => {
  const hasLocked = hasLockedFeedings(formFeedings);
  const feedings = formFeedings
    ? (formFeedings
        .map((formRow) =>
          formRow.items.map((rowItem) => {
            const isNewFeeding = typeof rowItem.feedingId === 'undefined' || rowItem.feedingId === newId;
            return {
              id: rowItem.feedingId,
              rationId: rowItem.id,
              feedingPeriodId: formRow.data.id,
              feedingFactor:
                (changedKey === ChangedKeys.GLOBAL_FEEDING_FACTOR || changedKey === ChangedKeys.HEAD_COUNT) &&
                isNewFeeding &&
                hasLocked
                  ? 0
                  : (changedKey === ChangedKeys.FEEDING_FACTOR && !rowItem.locked) ||
                    changedKey === ChangedKeys.FINAL_SAVE ||
                    ((changedKey === ChangedKeys.GLOBAL_FEEDING_FACTOR ||
                      changedKey === ChangedKeys.HEAD_COUNT ||
                      changedKey === ChangedKeys.OTHER) &&
                      !hasLocked)
                  ? transformFormValueToNumber(rowItem.reqPerc)
                  : undefined,
              loadWeight:
                changedKey === ChangedKeys.LOAD_WEIGHT ? transformFormValueToNumber(rowItem.loadWeight) : undefined,
              loadWeightDry:
                changedKey === ChangedKeys.LOAD_WEIGHT_DRY
                  ? transformFormValueToNumber(rowItem.loadWeightDry)
                  : undefined,
              rationStartDate: +rowItem.numberOfDays > 1 ? addDays(new Date(), -+rowItem.daysOnRation + 1) : undefined,
              locked: rowItem.locked,
              lockedWeight: rowItem.locked ? transformFormValueToNumber(rowItem.loadWeight) : undefined,
              feedingTime: rowItem.feedingTime?.substring(0, 5),
              feedingTimeNextDay: rowItem.feedingTimeNextDay,
            };
          }),
        )
        .reduce((acc, val) => {
          acc.push(...val);
          return acc;
        }, []) as any)
    : [];

  const ids: number[] = [];
  feedings.forEach((f) => {
    if (!ids.includes(f.id)) {
      ids.push(f.id);
    } else {
      f.id = undefined;
    }
  });
  return feedings;
};

const newId = '00000000-0000-0000-0000-000000000000';

export const formatGroupValues = (formGroup: GroupFormValue, isBeef: boolean, changedKey?: string) => {
  return {
    displayName: formGroup.displayName,
    globalFeedingFactor: Number(formGroup.globalFeedFactor),
    description: formGroup.groupName,
    groupTypeId: formGroup.groupTypeId,
    numberOfCows: !isBeef ? Number(formGroup.numberOfCows) : undefined,
    notInUse: formGroup.notInUse,
    feedings:
      // (changedKey === ChangedKeys.GLOBAL_FEEDING_FACTOR || changedKey === ChangedKeys.HEAD_COUNT) &&
      // formGroup?.feedings.some((feeding) => feeding?.items.some((item) => item.locked)) &&
      // !penHasNewFeedings
      //   ? undefined
      //   :
      formatFeedings(formGroup.feedings, changedKey),
    zoneId: formGroup.zoneId,
    showOnWidget: formGroup.showOnWidget,
    toleranceWeight: formGroup.toleranceWeight,
  };
};

export const formatDraggableFeedings = (
  feedingPeriods: FeedingPeriod[],
  feedings: Feeding[],
  recipes: Recipe[],
  draggableIds?: string[],
) => {
  return feedingPeriods.map((f, index): DragDropGroupState => {
    const feeding = feedings ? feedings.find((item) => item.feedingPeriodId === f.id) : null;

    let recipe;

    if (feeding) {
      recipe = recipes.find((item) => item.id === feeding.rationId);
    }

    return {
      items:
        feeding && recipe
          ? [
              {
                ...recipe,
                locked: feeding.locked,
                loadWeight: feeding.loadWeight,
                loadWeightDry: feeding.loadWeightDry,
                daysOnRation: feeding.daysOnRation,
                feedingId: feeding.id,
                reqPerc: feeding.feedingFactor,
                feedingTime: feeding.feedingTime?.substring(0, 5),
                feedingTimeNextDay: feeding.feedingTimeNextDay,
                draggableId: draggableIds && draggableIds[index] ? draggableIds[index] : generateUUID(),
              },
            ]
          : [],
      data: f,
    };
  });
};
